import React from 'react';
//import { useEffect } from 'react';
//import { useNavigate } from 'react-router-dom';
import { logger } from '../utils/logger';

function OAuth({ sessionToken }) {
  //const navigate = useNavigate();

  const handleOAuthLogin = () => {
    logger.log ('Starting OAUTH')
    const clientId = 'shelly-diy';
    const redirectUri = `${window.location.origin}/callback`;
    //const scope = 'email';
    const responseType = 'code';
    const state = `sh_${sessionToken}`;
    const authUrl = `https://my.shelly.cloud/oauth_login.html?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=${responseType}&state=${state}`;
    logger.log ("State:", state)
    // Redirect to the OAuth provider's URL
    window.location.href = authUrl;
  };
  
  return (
    <div className="provider-card">
    <h3 className="provider-title">Shelly</h3>
    <button 
      onClick={handleOAuthLogin}
      className="auth-button"
      disabled={!sessionToken}
    >
      Authenticate
    </button>

    </div>
  );
}

export default OAuth;